// extracted by mini-css-extract-plugin
export default {"preview":"styles__preview___80hRm","selectedPreview":"styles__selectedPreview___GmnDZ styles__preview___80hRm"};